<template>
    <div class="reveal">
        <component :is="currentReveal" v-bind="revealProps"></component>
    </div>
</template>

<script>
    import _ from 'lodash'
    import $ from 'jquery'
    import Foundation from 'foundation-sites/dist/js/npm'
    import Vue from 'vue'


    export default {
        name: 'reveal',

        beforeCreate() {
            if (typeof Vue.prototype.$modal === 'undefined') {
                Object.defineProperty(Vue.prototype, '$modal', {
                    value: this,
                    writable: false,//process.env.NODE_ENV === 'development'
                })
            }
        },

        props: [],

        mounted() {
            console.log('mounting modal');
            this.reveal = new Foundation.Reveal($(this.$el), {
                // These options can be declarative using the data attributes
                animationIn: 'slide-in-up fast',
                animationOut: 'slide-out-down fast'
            });

            this.reveal.$element.on('closed.zf.reveal', this.revealCloseHandler)
        },

        data() {
            return {
                reveal: null,
                currentReveal: null,
                revealProps: {}
            };
        },

        methods: {
            // Added the below openReveal method for two reasons:
            // 1) There was a bug preventing the reveal from working once
            // you navigated away and back to the reveal component.
            // 2) Most dialogs will need to be opened using code.
            openReveal(revealView, revealProps = {}) {
                this.closeReveal().then(() => {
                    this.currentReveal = revealView;
                    this.revealProps = revealProps;
                    this.$nextTick(() => this.reveal.open())
                })
            },

            /**
             * Close reveal and return promise.
             * @returns {Promise<any>}
             */
            closeReveal() {
                console.log("Called reveal close reveal");
                return new Promise((resolve, reject) => {
                    if (this.currentReveal === null) {
                        resolve();
                    } else {
                        const resolveOnClose = () => {
                            console.log("resolve on close");
                            resolve();
                            this.reveal.$element.off('closed.zf.reveal', resolveOnClose)
                        };
                        this.reveal.$element.on('closed.zf.reveal', resolveOnClose);
                        this.reveal.close();
                    }
                });
            },

            /**
             * Reveal closed event handler.
             * Clean up component after reveal has closed.
             */
            revealCloseHandler() {
                console.log('reveal close handler');
                this.currentReveal = null
            }
        },

        destroyed() {
            console.log('destroying modal');
            this.reveal.$element.off('closed.zf.reveal', this.revealCloseHandler);
            this.reveal.destroy();
            this.reveal = null;
        },
    };
</script>

<style lang="scss">
    @import '~motion-ui/src/motion-ui';
    @include motion-ui-transitions;
    @include motion-ui-animations;

    .reveal {
        &:focus {
            outline: none;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/common/Reveal.vue